import { render, staticRenderFns } from "./ContentBlocks.vue?vue&type=template&id=149d94ee&scoped=true&"
import script from "./ContentBlocks.vue?vue&type=script&lang=js&"
export * from "./ContentBlocks.vue?vue&type=script&lang=js&"
import style0 from "./ContentBlocks.vue?vue&type=style&index=0&id=149d94ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149d94ee",
  null
  
)

export default component.exports